import FeatureHighlightSection, { FeatureSection } from "@components/comparison-page-components/FeatureHighlightSection";
import AwardsSection from "@components/new-ui/AwardsSection";
import CaseStudyFeatureSection, { Feature } from "@components/new-ui/CaseStudyFeatureSection";
import ClientLogos from "@components/new-ui/ClientLogos";
import { container_classname } from "@components/new-ui/constants";
import CTASection from "@components/new-ui/CTASection";
import FeatureInfoCard, { FeatureInfo } from "@components/new-ui/IndustriesSection/FeatureInfoCard";
import Herosection, { HerosectionProps } from "@components/new-ui/IndustriesSection/Herosection";
import ProductSection, { Product } from "@components/new-ui/IndustriesSection/ProductSection";
import IntegrationSection from "@components/new-ui/IntegrationSection";
import NewLayout from "@components/new-ui/Layout";
import { IIndustries } from "@pages/industry/finance/whatsapp";
import React from "react";

const herosectionData: HerosectionProps = {
    chipTitle: "FOOD AND BEVERAGE",
    title: "Take orders and book tables using the WhatsApp Business Solution for restaurants",
    description:
        "Your phone won’t stop ringing — customers asking for today’s special, a table for four, or if you deliver. Meanwhile, half your reservations ghost you, and your staff is drowning in repetitive questions. WhatsApp automation solves it all.",
    primaryButtonText: "Start free trial",
    imageUrl: "https://assets.gallabox.com/gb-home/industries/food-beverage/food-and-beverage.png",
};

const featureInfo1: FeatureInfo = {
    mainTitle: "Order and delivery management hub",
    subtitle: "Track, confirm, deliver — all in one place.",
    imageUrl: "https://assets.gallabox.com/gb-home/industries/food-beverage/management-hub.png",
    featureInfoList: [
        "Monitor all orders (dine-in, take-away, catering) in a single dashboard.",
        "Assign orders to kitchen/ delivery teams and track fulfillment times.",
        "Auto-send delivery status updates: “Prepping your order!” → “10 mins away!”",
        "Sync with delivery apps (Zomato/Swiggy) to cut missed orders.",
    ],
};

const featureInfo2: FeatureInfo = {
    mainTitle: "AI chatbots for instant support",
    subtitle: "Introducing your 24/7 virtual assistant. ",
    imageUrl: "https://assets.gallabox.com/gb-home/industries/food-beverage/ai-chatbots.png",
    featureInfoList: [
        "Resolve FAQs: “What’s your specialty?” “What’s the catch of the day?”",
        "Auto-confirm orders, collect delivery addresses, and nudge payments.",
        "Send feedback requests after delivery: “Rate your meal!”",
        "Handle returns: “Issue with your order? Tap to start a return.”",
    ],
};

const featureInfo3: FeatureInfo = {
    mainTitle: "Click-to-order-WhatsApp Ads",
    subtitle: "Turn hungry scrollers into paying customers.",
    imageUrl: "https://assets.gallabox.com/gb-home/industries/food-beverage/click-to-order-whatsApp-ads.png",
    featureInfoList: [
        "Add an “Order Now” button to your Instagram and Facebook ads to let customers start chatting with you directly on WhatsApp.",
        "Auto-send menus or promo codes when they message.",
        "Follow-up abandoned carts: “Your cart is getting cold! Complete checkout for 15% off.”",
    ],
};

const featureInfo4: FeatureInfo = {
    mainTitle: "Smart CRM sync for smarter sales",
    subtitle: "Connect WhatsApp to your kitchen’s workflow",
    imageUrl: "https://assets.gallabox.com/gb-home/industries/food-beverage/smart-crm.png",
    featureInfoList: [
        "Sync orders with POS systems to avoid manual entry.",
        "Auto-tag customers: “Regular” → “Loves Biryani” → “Prefers COD”.",
        "Send payment reminders: “Prepay now & skip delivery fees!”",
        "Triggered automated reorder nudges: “Stock up! Your favorite coffee is back.”",
    ],
};

const ecommerceProductCardData: Array<Product> = [
    {
        imageUrl: "https://assets.gallabox.com/gb-home/solution/solution-icons/personalisation.svg",
        title: "Enhanced customer engagement",
        description: "Automate order confirmations, FAQs, and feedback collection in real time — saving up to 90% in hiring costs.",
    },
    {
        imageUrl: "https://assets.gallabox.com/gb-home/solution/solution-icons/bot.svg",
        title: "Automated responses",
        description: "Leverage smart chatbots to provide immediate resolution, qualify leads on the spot and drive business outcomes.",
    },
    {
        imageUrl: "https://assets.gallabox.com/gb-home/solution/solution-icons/group-chat.svg",
        title: "Centralized communication",
        description: "Send tailored promotions, updates, or reminders to segmented audiences from a single, intuitive dashboard.",
    },
    {
        imageUrl: "https://assets.gallabox.com/gb-home/solution/solution-icons/campaign.svg",
        title: "Cost-effective scalability",
        description: "You can launch WhatsApp campaigns in just a few minutes using Gallabox’s intuitive features.",
    },

    {
        imageUrl: "https://assets.gallabox.com/gb-home/solution/solution-icons/integrate.svg",
        title: "Seamless CRM integration",
        description: "Sync WhatsApp data with your existing CRM and other marketing automation tools for seamless workflows.",
    },
    {
        imageUrl: "https://assets.gallabox.com/gb-home/solution/solution-icons/data-analysis.svg",
        title: "Real-time data and analytics",
        description: "Monitor live engagement and conversion metrics, such as open rates, response times, and conversions, to refine strategies.",
    },
    {
        imageUrl: "https://assets.gallabox.com/gb-home/solution/solution-icons/share-circle.svg",
        title: "Multi-use collaboration",
        description: "Assign roles (sales, support, marketing) with granular permissions, ensuring teams work cohesively.",
    },
    {
        imageUrl: "https://assets.gallabox.com/gb-home/solution/solution-icons/checked.svg",
        title: "Built-in compliance guardrails",
        description: "Adhere to WhatsApp’s business policies and data regulations (GDPR, etc.) to avoid penalties and protect customer trust.",
    },
];

const featureSectionData: FeatureSection = {
    maintitle: "Why must restaurants use WhatsApp Business API?",
    featureSectionCard: [
        {
            imageUrl: "https://assets.gallabox.com/gb-home/industries/food-beverage/thunder-speed.png",
            title: "Fill tables faster",
            description: "Stop waiting for customers to find you — bring your menu to their phones.",
        },
        {
            imageUrl: "https://assets.gallabox.com/gb-home/industries/food-beverage/start-patch.png",
            title: "First bite to frequent visits",
            description: "Keep them coming back with personalized love, not generic spam.",
        },
        {
            imageUrl: "https://assets.gallabox.com/gb-home/industries/food-beverage/smile-circle.png",
            title: "Serve smiles, not just meals",
            description: "Turn ‘Where’s my order?’ panic into ‘Wow, that was quick!’ smiles.",
        },
    ],
};

const caseStudyFeatureCardData: Array<Feature> = [
    {
        mediaUrl: "https://assets.gallabox.com/gb-home/industries/ecommerce/hugg.png",
        chiptitle: "FOOD & BEVERAGE",
        title: "Maximizing Conversions and Streamlining Support: Hugg's Transformation with Gallabox",
        statsInfoData: [
            { percentage: "37%", label: "Improvement in CTWA" },
            { percentage: "30%", label: "Increase in conversion rates" },
            { percentage: "20%", label: "Growth in number of orders" },
        ],
        url: "https://gallabox.com/case-study/hugg",
    },
];

const FoodAndBeverageLanding: React.FC<IIndustries> = () => {
    return (
        <NewLayout
            title="WhatsApp Business solution for restaurant and food business"
            description="Boost orders and manage reservations with customers using a WhatsApp Business solution for food and beverage. Ideal for restaurants and food chains."
            canonical="https://gallabox.com/industry/food-beverage/whatsapp"
            ogAttributes={{ image: "https://assets.gallabox.com/gb-home/industries/food-beverage/food-and-beverage-og.png" }}
        >
            <Herosection herosection={herosectionData} />
            <section className={`${container_classname} my-10`}>
                <h3 className="text-center text-lg font-normal py-5">TRUSTED BY 10,000+ BUSINESSES</h3>
                <ClientLogos />
            </section>
            <h2 className="md:text-6xl text-4xl font-semibold pb-10 max-w-7xl mx-auto" style={{ fontFamily: "Degular Display" }}>
                The WhatsApp Business tool for restaurants & food businesses
            </h2>
            <p className="text-xl max-w-7xl mx-auto">A solution that fixes orders, bookings, and customer chaos.</p>

            <FeatureInfoCard {...featureInfo1} />
            <FeatureInfoCard {...featureInfo2} />
            <FeatureInfoCard {...featureInfo3} />
            <FeatureInfoCard {...featureInfo4} />

            <ProductSection productCardData={ecommerceProductCardData} title="Key benefits of integrating Gallabox into your tech stack" />
            <FeatureHighlightSection featureSection={featureSectionData} customStyle />
            <CaseStudyFeatureSection features={caseStudyFeatureCardData} />
            <IntegrationSection isLight={true} />
            <AwardsSection />
            <CTASection title="Growth in number of orders" description="Start free trial" />
        </NewLayout>
    );
};

export default FoodAndBeverageLanding;
